import { Children } from "react";
import {
  TableRow,
  TableHead,
  TableCell,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { memo } from "utils/memo";
import { get } from "lodash";

const TableHeader = ({
  columns = [],
  onChange = null,
  selectAllEmployees,
  selectAllCheckboxRef,
  selectedCheckBoxes,
  employees,
}: {
  columns: any;
  onChange: any;
  selectAllEmployees: any;
  selectAllCheckboxRef: any;
  selectedCheckBoxes: any;
  employees: any;
}) => {
  return (
    <TableHead>
      <TableRow>
        {Children.toArray(
          columns.map((column: any) => {
            let content;

            switch (column.type) {
              case "text":
                content = (
                  <Typography
                    variant="body1"
                    fontSize={14}
                    noWrap
                    fontWeight={600}
                  >
                    {column.label}
                  </Typography>
                );
                break;

              case "checkbox":
                content = (
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          inputRef={selectAllCheckboxRef}
                          checked={
                            selectedCheckBoxes.size > 0 &&
                            selectedCheckBoxes.size === employees.length
                          }
                        />
                      }
                      label=""
                      onChange={selectAllEmployees}
                    />
                  </FormGroup>
                );
                break;

              default:
                content = (
                  <Typography
                    variant="body1"
                    fontSize={14}
                    noWrap
                    fontWeight={600}
                    typography={"checkbox"}
                  >
                    {column.label}
                  </Typography>
                );
            }

            return (
              <TableCell
                key={column.label}
                align={get(column, "align", "")}
                sx={{
                  border: "none",
                  textTransform: "capitalize",
                  padding: 1,
                }}
              >
                {content}
              </TableCell>
            );
          })
        )}
      </TableRow>
    </TableHead>
  );
};

export default memo(TableHeader);
